import MedicationsTemplate from "../../features/pendingSignOffs/templates/MedicationsTemplate";

export default function MedicationsScreen() {
  return <MedicationsTemplate />;
}
